import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const egyptLakeLetoConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Egypt Lake-Leto Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Egypt Lake-Leto, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_egypt_lake_leto',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Egypt Lake-Leto',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Egypt Lake-Leto Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the residential neighborhoods 
     and lakefront properties of <strong>Egypt Lake-Leto</strong> with professional, 
     reliable tree care. This community near Tampa International Airport has 
     established homes with mature trees growing close to structures, driveways, 
     and utility lines. Florida's storm season turns those trees into hazards 
     quickly and our team handles the tough jobs safely and efficiently.`,

    `We specialize in <strong>dangerous tree removal and targeted trimming</strong> 
     overhanging limbs near homes and vehicles, storm split trunks, trees with 
     root instability near lakefront properties, and canopy reductions that 
     reduce storm risk across your property. We assess thoroughly and 
     execute carefully on every job.`,

    `<strong>Sam's Tree Service</strong> delivers trusted, affordable tree care 
     throughout <strong>Egypt Lake-Leto</strong> and surrounding 
     <strong>West Tampa</strong> communities keeping your property protected 
     and your trees healthy through every season.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Egypt Lake-Leto, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_EgyptLakeLeto = () => <LocationPage config={egyptLakeLetoConfig} />;
export default Services_EgyptLakeLeto;
